import { useState } from 'react';
import './MainScreen.css';
import PDFViewer from './PDFViewer';

const MainScreen = (props: any) => {

    const mainSwitcher = props.toggler ? {display: 'initial'} : {display: 'none'};
    const [ currentPageNo, updatePageNo ] = useState(1);


    const updatePDF = (z: string) => {

        if( currentPageNo < 0 ) {
            updatePageNo(1);
        } else {
            if( z == 'start' ) {
                updatePageNo(1);
                props.pdfUpdate1('USDB' + props.currentYear.toString() + '/' + props.currentYear.toString() + 'Page1.pdf');
                props.pdfUpdate2('USDB' + props.currentYear.toString() + '/' + props.currentYear.toString() + 'Page2.pdf');
            } else if( z == 'prev') {
                if( currentPageNo < 2 ) {
                    updatePageNo(1);
                } else if ( currentPageNo == 2 || currentPageNo <= props.currentCollection.length ) {
                    let tempNo = currentPageNo - 2;
                    updatePageNo( tempNo);
                    props.pdfUpdate1('USDB' + props.currentYear.toString() + '/' + props.currentYear.toString() + 'Page' + tempNo.toString() + '.pdf');
                    props.pdfUpdate2('USDB' + props.currentYear.toString() + '/' + props.currentYear.toString() + 'Page' + (tempNo + 1).toString() + '.pdf');
                }
    
            } else if( z == 'median') {
                let median = Math.floor(props.currentCollection.length / 2);

                updatePageNo(median);
                props.pdfUpdate1('USDB' + props.currentYear.toString() + '/' + props.currentYear.toString() + 'Page' + median.toString() + '.pdf');
                props.pdfUpdate2('USDB' + props.currentYear.toString() + '/' + props.currentYear.toString() + 'Page' + (median + 1).toString() + '.pdf');

            } else if( z == 'next') {
                let tempNo = currentPageNo + 2;
                updatePageNo(tempNo);
                props.pdfUpdate1('USDB' + props.currentYear.toString() + '/' + props.currentYear.toString() + 'Page' + tempNo.toString() + '.pdf');
                props.pdfUpdate2('USDB' + props.currentYear.toString() + '/' + props.currentYear.toString() + 'Page' + (tempNo + 1).toString() + '.pdf');
            } else if( z == 'last') {
                let last = props.currentCollection.length;

                updatePageNo(last -1);
                props.pdfUpdate1('USDB' + props.currentYear.toString() + '/' + props.currentYear.toString() + 'Page' + (last - 1).toString() + '.pdf');
                props.pdfUpdate2('USDB' + props.currentYear.toString() + '/' + props.currentYear.toString() + 'Page' + (last).toString() + '.pdf');
    
            } else {
                console.log('something eerie has happened around the control command center...');
            }
            console.log(currentPageNo);
        }
    }

    return (
        <div className='mainscreen'>
            { props.toggler ? 
            <div className='selected-year-page'>
                {props.display}
            </div>
            :
            <div className='selected-yearbook-display'>
                <div className='pdf-viewer-display'>
                    <PDFViewer pdfUrl={props.pdf1} pageNumber={1} />
                    <PDFViewer pdfUrl={props.pdf2} pageNumber={1} />
                </div>
                <div className='page-tracker'>
                    Page {' ' + currentPageNo.toString() + ' '} & {' ' + (currentPageNo + 1).toString() + ' '}  out of {' ' + props.currentCollection.length}

                </div>
                <div className='pdf-viewer-controls'>
                    <button className='start-button' onClick={()=> {
                        updatePDF('start');
                    }}>
                        Start
                    </button>
                    <button className='prev-button' onClick={() => {
                        updatePDF('prev');
                    }}>
                        Previous
                    </button>
                    <button className='median-button' onClick={() => {
                        updatePDF('median');
                    }}>
                        Median
                    </button>
                    <button className='next-button' onClick={() => {
                        updatePDF('next');
                    }}>
                        Next
                    </button>
                    <button className='last-button' onClick={() => {
                        updatePDF('last');
                    }}>
                        Last
                    </button>
                </div>
            </div>}
        </div>
    );
}

export default MainScreen;